import { IconButton, PersonAvatar } from '@teo/components';
import {
  ArrowLeft,
  DuoToneTrajectoryFilled,
  ChevronRight,
  Training,
  Evaluation,
} from '@teo/components/icons';
import { useNavigate } from 'react-router-dom';
import { nthLastIndexOf } from '@/util';

const CorrectionTrainingHeader = ({ learningpath, student, training }) => {
  const navigate = useNavigate();

  const basePath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 4)
  );

  return (
    <>
      <div className="flex items-center justify-between border-b border-solid border-grey-02 bg-white px-5 py-4">
        <div className="flex w-full flex-row gap-4 text-grey-07 sm:items-center">
          <div className="flex items-center">
            <IconButton
              className="my-auto"
              Icon={ArrowLeft}
              onClick={() =>
                navigate(
                  `${basePath}/learning-paths/correction/${learningpath?.id}/${student?.studentId}`
                )
              }
              variant="outline"
            />
          </div>
          <div className="flex items-center gap-2">
            <div className="rounded-md bg-primary-01 p-1 ">
              <DuoToneTrajectoryFilled className="h-4 w-4 fill-primary-05 text-primary-03" />
            </div>
            <p className="text-sm text-black">
              {learningpath?.lpgroupName || learningpath?.lpName}
            </p>
          </div>
          <div>
            <ChevronRight className="h-4 w-4 text-grey-07" />
          </div>
          <div className="flex items-center">
            <PersonAvatar
              inline
              id={student?.studentId}
              name={student?.username}
              imageSrc={student?.picture}
            ></PersonAvatar>
            <p className="text-sm text-black">{student?.username}</p>
          </div>
          <div>
            <ChevronRight className="h-4 w-4 text-grey-07" />
          </div>
          <div className="flex items-center gap-2">
            {training?.trainingType === 'training' ? (
              <div className="rounded-md bg-tint-green-light p-1 ">
                <Training className="h-4 w-4 text-tint-green-dark" />
              </div>
            ) : (
              <div className="rounded-md bg-tint-purple-light p-1 ">
                <Evaluation className="h-4 w-4 text-tint-purple-dark" />
              </div>
            )}
            <p className="text-sm text-black">{training?.trainingName}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorrectionTrainingHeader;
